// 常量池
export const USER_NAME_KEY = 'Jpom-UserName';

export const TOKEN_KEY = 'Jpom-Token';

export const LONG_TERM_TOKEN = 'Jpom-Long-Term-Token';

export const USER_INFO_KEY = 'Jpom-User';

export const MENU_KEY = 'Jpom-Menus';

export const TOKEN_HEADER_KEY = 'Authorization';

export const ACTIVE_TAB_KEY = 'Jpom-ActiveTab';

export const TAB_LIST_KEY = 'Jpom-TabList';

export const ACTIVE_MENU_KEY = 'Jpom-ActiveMenu';

export const GUIDE_FLAG_KEY = 'Jpom-GuideFlag';

export const GUIDE_HOME_USED_KEY = 'Jpom-Home-Guide-Used';

export const GUIDE_NODE_USED_KEY = 'Jpom-Node-Guide-Used';

export const NO_NOTIFY_KEY = 'tip';

export const NO_LOADING_KEY = 'loading'
